import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuditingModel } from '../models/auditing.model';
import { AnalyticsReportModel } from '../models/analyticsReport.model';
import { AnalyticsUsersReportModel } from '../models/analyticsUsersReport.model';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class AuditingService {
  private configCoreUrl: string;
  private regionId: number;

  constructor(private infraService: InfraService, private http: HttpClient) {

    this.infraService.infraDetails$.subscribe(data => {
      this.configCoreUrl = data.WebEndPoint2 + 'auditing';
      this.regionId = data.InfraId;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }

  public addAudit(engagementId: number, functionalityName: string, databookType?: string, mappingLevel?: string) {
    const auditingModel = new AuditingModel;
    {
      auditingModel.RegionId = this.regionId,
      auditingModel.EngagementId = engagementId,
      auditingModel.FunctionalityName = functionalityName;
      auditingModel.TypeOfDatabook = databookType;
      auditingModel.mappingLevel = mappingLevel;
    }
    return this.http.post(`${this.configCoreUrl}`, auditingModel);
  }

  public getAnalyticsData() {
    return this.http.get<AnalyticsReportModel[]>(`${this.configCoreUrl}/GetAnalyticsData`);
  }

  public getUsersAnalyticsData(fromDate: string, toDate: string) {
    return this.http.get(`${this.configCoreUrl}/GetUsersAnalyticsData?fromDate=` + fromDate + `&toDate=` + toDate);
  }

  public getAnalyticsDataExcel(selectedCountryStr: string, langCode: string) {
    return this.http.get(`${this.configCoreUrl}/GetAnalyticsDataFile?selectedCountry=${selectedCountryStr}&langCode=${langCode}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getUsersAnalyticsDataExcel(fromDate: string, toDate: string, langCode: string) {
    return this.http.get(`${this.configCoreUrl}/GetUsersAnalyticsDataFile?fromDate=${fromDate}&toDate=${toDate}&langCode=${langCode}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getActvityDetailsExcel(engagementId: number) {
    return this.http.get(`${this.configCoreUrl}/GetActivityDetails?engagementId=` + engagementId, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getUserEngagememtDataExcel() {
    return this.http.get(`${this.configCoreUrl}/GetUserEngagememtDataFile`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }
}
